import { useQuery } from "react-query";
import { fetchTicket } from "../services/api/tickets";

export default function useTicket(id: string) {
	return useQuery(["Tickets", id], () => fetchTicket(id), {});
}
